import JoinDiscordInfoCard from "@core-components/JoinDiscordInfoCard";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Container } from "@mantine/core";
import SEO from "@modules/seo/SEO";
import { Trans } from "react-i18next";
import HelpCenterContainer from "../components/HelpCenterContainer";
import HelpCenterText from "../components/HelpCenterText";

const HowToHandleBannedAccount = () => {
  const { t } = useAppTranslation("pages.helpCenter");

  return (
    <>
      <SEO
        title={t("bannedAccount.seo.title")}
        description={t("bannedAccount.seo.description")}
      />
      <HelpCenterContainer title={t("bannedAccount.title")}>
        <HelpCenterText className="!mb-0">
          {t("bannedAccount.text1")}
        </HelpCenterText>
        <HelpCenterText className="!mt-4">
          <Trans i18nKey="pages.helpCenter.bannedAccount.text2">
            Très rarement, votre compte peut être banni sans que ce soit de
            votre faute.
            <br />
            Rejoignez notre serveur Discord et ouvrez un ticket pour obtenir une
            assistance rapide.
          </Trans>
        </HelpCenterText>

        <Container className="!max-w-[500px] mt-16 p-0">
          <JoinDiscordInfoCard text={t("bannedAccount.discordText")} />
        </Container>
      </HelpCenterContainer>
    </>
  );
};

export default HowToHandleBannedAccount;
